<template>
	<div class="box">
		<div class="login_container">
			<div class="loginBox">
				<div class="loginBoxR">
					<el-form ref="userLoginParamRef" class="loginForm" :model="userLoginParam"
						:rules="userLoginParamRules">
						<img class="logo" src="@/assets/picture/logo.png">
						<el-form-item prop="loginName" label="">
							<el-input :placeholder="$t('login.txt1')" v-model="userLoginParam.loginName">
							</el-input>
						</el-form-item>
						<el-form-item prop="password" label="">
							<el-input :placeholder="$t('login.txt2')" show-password  @keydown.enter.native="login" v-model="userLoginParam.password">
							</el-input>
						</el-form-item>
						<el-button class="loginSumbit" @click="login" type="primary" round>{{$t("login.txt3")}}</el-button>
					</el-form>
				</div>
			</div>
				<div class="copyrightBox">
				<p class="txt-block">
					<label style="text-decoration:none;color:#999">{{copyRightInfo}}</label>
				</p>
				
  				<p class="txt-block" v-if="policeRegistrationNumber">
  					<img width="15px" height="15px" :src='policeRegistrationIcon' style="margin-right: 8px;margin-bottom: 4px;" /> 
  					<a href="https://beian.mps.gov.cn/#/query/webSearch?code=31010502001315" target="_blank" rel="noreferrer" style="text-decoration:none;color:#999" >{{policeRegistrationNumber}}</a> 
  				</p>
  				<p class="txt-block" v-if="domainNameRegistrationNumber">
  					<a href="https://beian.miit.gov.cn" target="_blank" style="text-decoration:none;color:#999" >{{domainNameRegistrationNumber}}</a>
  				</p>
  				
			</div>
		</div>
	</div>
</template>

<script>
	import {
		crytoLogin
	} from "@/plugins/index.js";
	import qs from 'qs';

	import {
		suppressDeprecationWarnings
	} from 'moment';
	export default {

		data() {
			return {
				code:"",
				copyRightInfo:'',//版权信息
				policeRegistrationIcon:'',//底部图标
				policeRegistrationNumber:'',//备案号1
				domainNameRegistrationNumber:'',//备案号2
				logoUrl:'',
				checked: false,
				show: true,
				count: '',
				timer: null,
				userLoginParam: {
					loginName: '',
					password: '',
				},
				codePic: '',
				//表单验证规则对象
				userLoginParamRules: {
					loginName: [{
						required: true,
						message: this.$t('login.txt1'),
						trigger: "blur"
					}, ],
					password: [{
						required: true,
						message: this.$t('login.txt2'),
						trigger: "blur"
					}, ],
				},
			};
		},
		created(){
			let lang = localStorage.getItem('language') || 'cn';
			this.getSystemPublicConfigs(lang);
		},
		mounted() {
			// 获取code参数
			this.code = this.getUrlPara("code"); 
  			// 如果code不为空，则判断为快速登录
  			if(this.code){
  				var strCode = this.uncode(this.code); //解密code
  				this.userLoginParam.loginName = this.getUrlParaOfURL("?"+strCode,"loginName"); //得到账号
				this.userLoginParam.password = this.getUrlParaOfURL("?"+strCode,"password");   //得到密码
				this.login();
  			}
		},
		methods: {
			// 获取账号和密码
			getUrlParaOfURL(url,key) {
				//var url = window.location.search;
				var reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)");
				var result = url.substr(1).match(reg);
				return result ? decodeURIComponent(result[2]) : null;
			},
			// 解密code
			uncode(ucodes){
				var str = [];
				var arry = ucodes.split(",");
				for (var i = 0; i < arry.length; i++) {
					var un = String.fromCharCode(parseInt(arry[i]));
					str.push(un);
				}
				return str.join("");			
			},
			// 获取code参数
			getUrlPara(key) {
				var url = window.location.search;
				var reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)");
				var result = url.substr(1).match(reg);
				return result ? decodeURIComponent(result[2]) : null;
			},
			 // 获取系统语言
        	async getSysLanguage() {
        	    const { data: res } = await this.$http.post('/sysLanguage/getSysLanguage');
        	    let lang = res.result.selected || 'cn';
        	   localStorage.setItem('language',lang);
        	   // location.reload();
        	   const cbUrl = this.$route.query.cbUrl;
			   if(cbUrl) {
			   	return this.$router.replace(decodeURIComponent(cbUrl));
			   }
			    this.$router.push({path: '/workPlat', query: {isLogin: true}});
        	   	// this.getSystemPublicConfigs(lang);
        	},
			async login() {
				this.$refs.userLoginParamRef.validate(async valid => {
					if (!valid) return;
					let fromData = {};
					if(this.code){
						fromData = {
							loginName: this.userLoginParam.loginName,
							password: this.userLoginParam.password
						}
					}else{
						fromData = {
							loginName: this.userLoginParam.loginName,
							password: crytoLogin(this.userLoginParam.password).rsaData
						}
					}
					const loading = this.$loading({
							lock: true,
							text: 'Loading',
							spinner: 'el-icon-loading',
							background: 'rgba(0, 0, 0, 0.7)'
					});
					const {
						data: res
					} = await this.$http.post("/user/info/login?" + qs.stringify(fromData));
					loading.close()
					if (!res.success) {
						return this.$message.error(res.message);
					}
					let roleId = res.result.user.id;
					let token = res.result.token;
					let userId = res.result.user.id;
					let loginName = res.result.user.userName;
					localStorage.loginName = this.userLoginParam.userName;
					localStorage.password = fromData.password
					window.sessionStorage.setItem("roleId", roleId);
					window.sessionStorage.setItem("token", token);
					window.sessionStorage.setItem("loginName", loginName);
					window.sessionStorage.setItem("puuid", fromData.password);
					window.sessionStorage.setItem("userId", userId);
					window.sessionStorage.setItem("enableDowloadUserData", res.result.permission.enableDowloadUserData);
					localStorage.setItem('userInfo', JSON.stringify(res.result.user))
					localStorage.setItem('roleId', roleId)
					localStorage.setItem('token', token)
					localStorage.setItem('userId', userId)
                    await this.$store.dispatch('GET_USER_MENU')
                    this.getSysLanguage();//获取系统语言
				});
			},
			// 获得系统公开的配置信息
			async getSystemPublicConfigs(lang) {
				const { data: res } = await this.$http.get("/active/getSystemPublicConfigs");
				if (!res.success) {
					return this.$message.error(res.message);
				}
				if(lang == 'cn'){
					this.copyRightInfo = res.result.copyrightInfo.cn.copyright;
					this.policeRegistrationIcon = res.result.copyrightInfo.cn.policeRegistrationIcon;
					this.policeRegistrationNumber = res.result.copyrightInfo.cn.policeRegistrationNumber;
					this.domainNameRegistrationNumber = res.result.copyrightInfo.cn.domainNameRegistrationNumber;
				}else{
					this.copyRightInfo = res.result.copyrightInfo.en.copyright;
					this.policeRegistrationIcon = res.result.copyrightInfo.en.policeRegistrationIcon;
					this.policeRegistrationNumber = res.result.copyrightInfo.en.policeRegistrationNumber;
					this.domainNameRegistrationNumber = res.result.copyrightInfo.en.domainNameRegistrationNumber;
				}
				this.logoUrl = res.result.logoBase64Images;
			},
			// 跳转工信部
			goPage(){
				let url = "https://beian.miit.gov.cn";
				window.open(url,"_blank") 
			}
		}
	};
</script>

<style lang="less" scoped>
	.box {
		width: 100%;
		height: 100%;
		background-image: url("../assets/picture/-s-bg_img.png");
		background-repeat: no-repeat;
		background-size: 100% 100%;
	}
	.login_container {
		min-width: 450px;
		position: fixed;
		left: 50%;
		top: 50%;
		transform: translate(-50%,-50%); 
	}

	.loginBox {
		.fl {
			float: left;
		}
		.logo{
			display: block;
			width: 186px;
			height: 40px;
			margin: 0 auto;
			margin-bottom: 4rem;
		}
		.loginBoxR {
			background: #fff;
			color: #333;
			display: block;
			margin: 0 auto;
			margin-top: 10%;
			border-radius: 30px;

			/deep/ .el-form-item__label {
				font-size: 15px;
			}

			/deep/ .el-form-item {
				margin-bottom: 20px;
			}

			/deep/ .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
				display: none;
			}

			/deep/ .el-input__inner {
				border: none;
				/*width: 360px;*/
				height: 36px;
				background: #F4F4F4;
                color: #333;
				border-radius: 100px;
			}

			/deep/ .el-input__inner:visited {
				background: #ffffff;
			}

			/deep/ .el-input {
				/*width: 360px;*/
				height: 36px;
				background: #F4F4F4;
				border: none;
				border-radius: 100px;
			}

			/deep/ .el-input-group__append {
				background: none;
				border: none;
				color: #152647;
			}

			/deep/ .el-input__prefix {
				margin-left: 32px;
			}

			.loginBoxRTitle {
				font-size: 12px;
				font-family: Microsoft YaHei;
				font-weight: 400;
				color: #333333;
				padding-top: 45px;
				padding-left: 438px;
				text-align: left;
			}

			.border {
				border: 1px solid #dcdfe6;
				width: 100%;
				height: 100%;
				display: inline-block;
				border-radius: 5px;
			}

			.loginForm {
				box-sizing: border-box;
				padding:40px 30px;
				background: #FFFFFF;
				border-radius: 30px;
				font-size: 2.4rem;
				font-weight: 400;
				color: #333333;

				.title {
					font-size: 2.4rem;
					font-weight: 400;
					color: #333333;
					text-align: center;
				}
			}

			.changeCode {
				color: #007EFF;
				cursor: pointer;

				i {
					font-size: 20px;
				}

				p {
					font-size: 6px;
					margin-top: -25px;
				}
			}

			.loginSumbit {
				width:88px;
				margin: 0 auto;
				display: block;
				margin-top: 30px;
				height: 36px;
				background: #1B3B7C;
				border-radius: 18px;
				border: none;
				padding: 0;
				line-height: 36px;
			}

			.forgetBtn {
				font-size: 7px;
				font-weight: bold;
				color: #7B7B7B;
				line-height: 43px;
				display: block;
				text-align: right;
				margin-right: 20px;
				cursor: pointer;
			}
		}

	}
	.copyrightBox{
		text-align: center;
		margin-top: 9.5rem;
		cursor: pointer;
		.txt-block{
			display: block;
			margin-bottom: 10px;
		}
	}


	.w400 {
		width: 400px;
	}
</style>
